import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import EnhancedToolbar from '../../widgets/Toolbar';
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import { ViewContainer } from "./../../View.jsx";
import ViewUtils from "./../../ViewUtils";
import AlertItem from "../../widgets/AlertItem";
import { LearnerTradeForm } from '../../etqa/program/registration/LearnerTradeForm';

const TradeRef = React.createRef();
const utils = new ViewUtils();

class AddLearnerTrade extends Component {

    constructor(props) {
        super(props);
        this.state = {
            model: {
                ProviderID: null,
                EmployerID: null
            },
            TradeDetails: {
                TradeProgrammeDescription: "",
                TradeProgrammeCode: ""
            },
            messageStyle: "message",
            id: null,
            showTable: true,
            CurrentProgramme: this.props.location.state.TradeID,
            CreateNewFlag: this.props.location.state.hideFields,
            Learner: this.props.location.state.LearnerID,
            currentIsCentresOfSpecialisations: null
        };

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: '', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                }
                ,
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'save', label: '', tooltip: 'Save', icon: 'SaveIcon' },
                        { id: 'documents', label: 'DOCUMENTS', tooltip: 'Documents', disabled: (this.props.location.state.hideFields), visible: !(this.props.location.state.hideFields) }
                    ]
                }
            ]
        }
    }

    componentDidMount() {
        if (utils.isNull(this.props.location.state.TradeID) || this.props.location.state.TradeID === 0)
        {
            this.defaultSponsorship()
        }
    }

    handleFormValueChange = (values) => {
        if (!utils.isNull(values)) {

            this.setState({
                TradeSetupDetails: {
                    TradeProgrammeCode: values.TradeID,
                    TradeProgrammeDescription: values.TradeTitle
                },
                Learner: this.props.location.state.LearnerID
            });

            let newValues = null;
            if (!utils.isNull(values)) {
                newValues = { ...values };
            }
            if (!utils.isNull(newValues)) {
                if (JSON.stringify(this.state.model) !== JSON.stringify(newValues)) {
                    this.setState({
                        model: newValues,
                    });
                }
            }

            this.ECCheck(values);
        }
    }

    ECCheck(values) {
        if (!utils.isNull(values)) {
            if (!utils.isNull(values.EmployerID)) {
                let url = "api/sims/learner/EmployerContactCheck?EmployerID=" + values.EmployerID.Id;
                utils.invokeUrl(url, (response) => {
                    if (response.Result != "") {
                        this.setState({
                            message: response.Result,
                            messageStyle: "ERROR",
                        })
                    }
                },
                    null,
                    {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': "Bearer " + localStorage.getItem("token")
                        }
                    }
                )
            }
        }
    }

    onChangeProviderIDHandler = (form, id, event) => {
        let newModel = { ...form.values }
        newModel.ProviderContactID = null;
        this.setState({ model: newModel, clearOptions: true })
    }

    onChangeEmployerIDHandler = (form, id, event) => {
        let newModel = { ...form.values }
        newModel.EmployerContactID = null;
        this.setState({ model: newModel, clearOptions: true })
    }

    clearOptionsHandler = () => {
        this.setState({ clearOptions: false });
    }


    handleToolbarButtonClick(buttonId) {
        if ("save" === buttonId) {
            this.save();
        } else if ("close" === buttonId) {
            this.closeView();
        } else if ("documents" === buttonId) {
            this.props.history.push({
                pathname: '/learnerTradeDocuments',
                state: {
                    LearnerID: this.props.location.state.LearnerID,
                    LearnerArtisanID: this.props.location.state.TradeID,
                    hideFields: false,
                    learnerNames: this.props.location.state.learnerNames,
                    permissions: this.props.location.state.permissions
                }
            });
        }
    }

    successCallback = (response) => {
        if (response.MessageType === "SUCCESS") {
            this.setState({
                showTable: false
            }, () => {
                this.setState({
                    showTable: true,
                    message: response.Message,
                    messageStyle: response.MessageType,
                    CurrentProgramme: response.EntityId,
                    CreateNewFlag: false
                })
            });
        }
        else {
            this.setState({
                message: response.Message, messageStyle: response.MessageType
            });
        }
    }

    defaultSponsorship = () => {
        let url = "api/sims/LearnerTrade/GetCurrentRole";
        utils.invokeUrl(url, (response) => {
            if (response.Result === "Provider" || response.Result === "AET Agent" || response.Result === "Agent") {
                this.setState({
                    model: {
                        SponsorshipID: { Id: 2, Description: "Industry Funded" }
                    }
                })
            }
        },
            null,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    }

    save() {
        let formValue = TradeRef.current.getValue();
        if (formValue !== null && typeof formValue !== "undefined") {
            formValue.id = this.props.location.state.LearnerID;
            let input = JSON.stringify(formValue);

            utils.invokeUrl("api/sims/learnerTrade/LinkLearnerTrade", (response) => {
                this.setState({ currentIsCentresOfSpecialisations: formValue.IsCentresOfSpecialisations })
                this.successCallback(response);
            }, () => { alert(utils.SYSTEM_ERROR_MESSAGE) }, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                body: input
            });
        }
    }

    closeView() {
        this.props.history.push({
            pathname: '/LearnerTradeSearch',
            state: {
                learnerID: this.props.location.state.LearnerID,
                learnerNames: this.props.location.state.learnerNames
            }
        });
    }

    dataArrivedHandler = (values) => {
        if (!utils.isNull(values["IsCentresOfSpecialisations"]) && utils.isNull(this.state.currentIsCentresOfSpecialisations) && !utils.isNull(this.state.CurrentProgramme)) {
            this.setState({ currentIsCentresOfSpecialisations : values["IsCentresOfSpecialisations"] });
        }
    }

    render() {
        return (
            <ViewContainer topPadding="0" title="">
                <p className="breadcrumbs">
                    {
                        (this.props.location.state.hideFields) ?
                            `Learner > Link New Artisan > ${this.props.location.state.learnerNames}`
                            :
                            `Learner > Update Artisan > ${this.props.location.state.learnerNames}`
                    }
                </p>
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />
                <table width="100%">
                    <tbody>
                        <tr>
                            <td>
                                <EnhancedToolbar highlight={false}
                                    title=""
                                    buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                                    config={this.toolbarConfig} />
                            </td>
                        </tr>
                        <tr>
                            <td className="formContainer">
                                <div style={{ height: "65%", maxHeight: "80vh" }}>
                                    {this.state.showTable === true && (
                                        <LearnerTradeForm ref={TradeRef}
                                            viewRef={this}
                                            id={this.state.CurrentProgramme}
                                            hideFields={this.state.CreateNewFlag}
                                            editPermission={this.props.location.state.permissions}
                                            viewOnly={this.props.location.state.viewOnly}
                                            lid={this.props.location.state.LearnerID}
                                            valueChangeHandler={(values) => this.handleFormValueChange(values)}
                                            model={this.state.model}
                                            data={this.state.model}
                                            onChangeProviderIDHandler={this.onChangeProviderIDHandler}
                                            onChangeEmployerIDHandler={this.onChangeEmployerIDHandler}
                                            dataArrivedHandler={(values) => this.dataArrivedHandler(values)}
                                            currentIsCentresOfSpecialisations={this.state.currentIsCentresOfSpecialisations}
                                        />
                                    )}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ViewContainer>
        );
    }
}

export default withRouter(AddLearnerTrade);
